import React from 'react';

const Alerts = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Alerts & Notifications</h1>
      <p className="text-gray-600">Notification system coming soon...</p>
    </div>
  );
};

export default Alerts;